<template>
  <svg
    :fill="iconColor"
    :width="iconSize"
    :height="iconSize"
    id="icon_master"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <title>Master Icon</title>
    <path
      d="M14.19,12.94A2.17,2.17,0,1,0,12,10.77,2.18,2.18,0,0,0,14.19,12.94Zm0-.69a1.47,1.47,0,0,1-1.42-1.14h2.85A1.47,1.47,0,0,1,14.19,12.25Zm0-2.95a1.48,1.48,0,0,1,1.43,1.12H12.77A1.48,1.48,0,0,1,14.19,9.3Z"
    />
    <path
      d="M11.1,10.77a2.17,2.17,0,1,0-2.17,2.17A2.17,2.17,0,0,0,11.1,10.77ZM8.93,9.3a1.47,1.47,0,0,1,1.42,1.12H7.51A1.48,1.48,0,0,1,8.93,9.3Zm0,2.95A1.49,1.49,0,0,1,7.5,11.11h2.86A1.47,1.47,0,0,1,8.93,12.25Z"
    />
    <path
      d="M13.53,15.59a.35.35,0,0,0-.35-.35H9.94a.35.35,0,0,0,0,.7h3.24A.35.35,0,0,0,13.53,15.59Z"
    />
    <path
      d="M21.76,8a2.27,2.27,0,0,0-.85-.34,2,2,0,0,0-1.71.44,4.5,4.5,0,0,1-1.33.58,2.11,2.11,0,0,0-.75.45,7,7,0,0,0-2-3.16.31.31,0,0,0-.24-.19,5.89,5.89,0,0,0-3.31-1.24A5.83,5.83,0,0,0,8.26,5.78.35.35,0,0,0,8,6,6.94,6.94,0,0,0,6,9.22a2.59,2.59,0,0,0-.8-.45,4.51,4.51,0,0,1-1.39-.62,1.94,1.94,0,0,0-1.65-.48,2.5,2.5,0,0,0-.85.42l-.17.18.17.44.22,0a1.89,1.89,0,0,1,1.62,1.73,4.93,4.93,0,0,0,2.34,2.7A3,3,0,0,0,6,14.84a5.42,5.42,0,0,0,4.08,4.38,2.07,2.07,0,0,0,1.2.59l.25,0,.25,0A2.1,2.1,0,0,0,13,19.22a5.41,5.41,0,0,0,4.07-4.36,2.68,2.68,0,0,0,.56-1.63v-.1a5,5,0,0,0,2.28-2.8,1.84,1.84,0,0,1,1.62-1.68l.24,0,.13-.45Zm-18,2.27h0a2.66,2.66,0,0,0-1.3-2h0c.28,0,.52.16,1,.45A5,5,0,0,0,5,9.45a2.5,2.5,0,0,1,.81.52,20.93,20.93,0,0,0-.32,2.45A4.52,4.52,0,0,1,3.8,10.28ZM7,15.73l.29.17a4.69,4.69,0,0,1,2,1.88,3.52,3.52,0,0,1,.22.49A4.79,4.79,0,0,1,7,15.73Zm4.4,3.39a1.46,1.46,0,0,1-.94-.55.76.76,0,0,1-.11-.14,1.54,1.54,0,0,1-.17-.34,6,6,0,0,0-.29-.64,5.42,5.42,0,0,0-2.27-2.17,3.58,3.58,0,0,1-.68-.48,2,2,0,0,1-.31-.34v0a2.17,2.17,0,0,1-.44-1.31h0c0-.09,0-.19,0-.28,0-.24,0-.47,0-.7a.86.86,0,0,1,0-.16c0-.54.12-1,.19-1.46l0-.15c0-.16.06-.31.08-.43.06-.29.11-.48.11-.48a6.22,6.22,0,0,1,1.82-3c.53.16.65,1.18.65,1.2A.35.35,0,0,0,9.46,8h0a.36.36,0,0,0,.32-.38A2.45,2.45,0,0,0,9.07,6a5.19,5.19,0,0,1,.77-.4l.1,0a.31.31,0,0,1,.22.09,2.64,2.64,0,0,1,.33,1.55.35.35,0,0,0,.33.37h0a.36.36,0,0,0,.35-.34,3.54,3.54,0,0,0-.46-2,6.09,6.09,0,0,1,.84-.11,4,4,0,0,1,.82.1,3.56,3.56,0,0,0-.52,2,.35.35,0,0,0,.35.35h0a.36.36,0,0,0,.35-.36A2.66,2.66,0,0,1,13,5.76a.3.3,0,0,1,.22-.1l.12,0a5.5,5.5,0,0,1,.76.39,2.53,2.53,0,0,0-.81,1.58.36.36,0,0,0,.3.4h0a.34.34,0,0,0,.34-.3s.19-1.06.73-1.21a6.27,6.27,0,0,1,1.82,2.94s.07.29.15.72v0c0,.14.05.3.08.47h0c0,.17.06.36.09.56v0l.06.54a.34.34,0,0,1,0,.1c0,.2,0,.39.05.59v.12c0,.2,0,.4,0,.59a2.12,2.12,0,0,1-.4,1.19l0,0a2.61,2.61,0,0,1-.27.31,3.67,3.67,0,0,1-.75.54,5.36,5.36,0,0,0-2.27,2.17,3.62,3.62,0,0,0-.29.64,1.38,1.38,0,0,1-.28.48,1.46,1.46,0,0,1-.95.55Zm2.25-.85a3.6,3.6,0,0,1,.23-.49,4.62,4.62,0,0,1,.35-.55,5.12,5.12,0,0,1,1.62-1.33l0,0a1.35,1.35,0,0,0,.26-.15A4.72,4.72,0,0,1,13.64,18.27Zm5.61-8.12a4.59,4.59,0,0,1-1.62,2.23,2,2,0,0,0,0-.25l0-.4,0-.26c0-.14,0-.28-.05-.41s0-.15,0-.23l-.06-.37a1.43,1.43,0,0,0,0-.22,2.16,2.16,0,0,0-.05-.27s0-.05,0-.08a2.24,2.24,0,0,1,.75-.52,5.54,5.54,0,0,0,1.54-.68,1.64,1.64,0,0,1,.83-.37A2.7,2.7,0,0,0,19.25,10.15Z"
    />
  </svg>
</template>
<script>
export default {
  data() {
    return {
      iconColor: "white",
      iconSize: "32px"
    };
  },
  created() {
    if (this.size) this.iconSize = this.size + "px";
  },
  mounted() {
    if (this.color) this.iconColor = this.getColor(this.color);
  },
  props: ["color", "size"]
};
</script>
<style>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -6px;
}
</style>